<div class="container pt-4 mb-4">
  <span class="font-gray-small">Atendimento</span>
  <div class="description-text description-text__blue pt-0">Ouvidoria</div>

  <div class="container">

    <div class="font-gray-small pb-4">Enviar e-mail</div>

    <form [formGroup]="formOuvidoria" (submit)="onSubmit('Ouvidoria')">


      <div class="container">
        <div class="row ">

          <div class="col-md-6">
            <div class="form-group">
              <select formControlName="quemSou" class="form-select"
                [class.error]="formOuvidoria.controls['quemSou'].errors?.['required'] && (formOuvidoria.controls['quemSou'].dirty || (formOuvidoria.controls['quemSou'].touched)|| submitted)">
                <option disabled selected value="">Quem sou?</option>
                <option *ngFor="let option of optionsQuemSou" [value]="option.value">
                  {{ option.viewValue }}
                </option>
              </select>
              <span class="text-danger"
                *ngIf="formOuvidoria.controls['quemSou'].errors?.['required'] && (formOuvidoria.controls['quemSou'].dirty || (formOuvidoria.controls['quemSou'].touched)|| submitted)">
                Selecione um campo.
              </span>
            </div>


          </div>


          <div class="col-md-6">
            <div class="form-group">
              <input class="form-control  global-input-style" formControlName="nome" type="text" name="nome"
                (change)="saverange($event, 'nome')" placeholder="Nome"
                [class.error]="formOuvidoria.controls['nome'].errors && (formOuvidoria.controls['nome'].dirty || (formOuvidoria.controls['nome'].touched) || submitted)" />

              <span class="text-danger"
                *ngIf="formOuvidoria.controls['nome'].errors?.['required'] && (formOuvidoria.controls['nome'].dirty || (formOuvidoria.controls['nome'].touched) || submitted)">
                Nome é necessário.
              </span>
              <span class="text-danger"
                *ngIf="!formOuvidoria.controls['nome'].errors?.['required'] && (formOuvidoria.controls['nome'].dirty || (formOuvidoria.controls['nome'].touched) || submitted) && formOuvidoria.controls['nome'].errors">
                Nome inválido.
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input class="form-control global-input-style " formControlName="email" type="text" placeholder="E-mail"
                (change)="saverange($event, 'email' )"
                [class.error]="formOuvidoria.controls['email'].errors && (formOuvidoria.controls['email'].dirty || (formOuvidoria.controls['email'].touched)|| submitted)" />

              <span class="text-danger"
                *ngIf="formOuvidoria.controls['email'].errors?.['required'] && (formOuvidoria.controls['email'].dirty || (formOuvidoria.controls['email'].touched)|| submitted)">
                E-mail é necessário.
              </span>
              <span class="text-danger"
                *ngIf="!formOuvidoria.controls['email'].errors?.['required'] && (formOuvidoria.controls['email'].dirty || (formOuvidoria.controls['email'].touched)|| submitted) && formOuvidoria.controls['email'].errors">
                E-mail inválido.
              </span>

            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <input class="form-control global-input-style" formControlName="telefone" type="text"
                mask="(00)0000-0000 || (00)00000-0000 " placeholder="Telefone"
                [class.error]="formOuvidoria.controls['telefone'].errors && (formOuvidoria.controls['telefone'].dirty || (formOuvidoria.controls['telefone'].touched)|| submitted)" />
              <span class="text-danger"
                *ngIf="formOuvidoria.controls['telefone'].errors?.['required'] && (formOuvidoria.controls['telefone'].dirty || (formOuvidoria.controls['telefone'].touched)|| submitted)">
                Telefone é necessário.
              </span>
              <span class="text-danger"
                *ngIf="!formOuvidoria.controls['telefone'].errors?.['required'] && (formOuvidoria.controls['telefone'].dirty || (formOuvidoria.controls['telefone'].touched)|| submitted) && formOuvidoria.controls['telefone'].errors">
                Telefone inválido.
              </span>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <input class="form-control global-input-style" type="text" formControlName="endereco"
                (change)="saverange($event, 'endereco')" placeholder="Endereço"
                [class.error]="formOuvidoria.controls['endereco'].errors && (formOuvidoria.controls['endereco'].dirty || (formOuvidoria.controls['endereco'].touched)|| submitted)" />

              <span class="text-danger"
                *ngIf="formOuvidoria.controls['endereco'].errors?.['required'] && (formOuvidoria.controls['endereco'].dirty || (formOuvidoria.controls['endereco'].touched)|| submitted)">
                Endereço é necessário.
              </span>
              <span class="text-danger"
                *ngIf="!formOuvidoria.controls['endereco'].errors?.['required'] && (formOuvidoria.controls['endereco'].dirty || (formOuvidoria.controls['endereco'].touched)|| submitted) && formOuvidoria.controls['endereco'].errors">
                Endereço inválido.
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input class="form-control global-input-style" formControlName="cep" type="text" mask="00000-000"
                placeholder="CEP"
                [class.error]="formOuvidoria.controls['cep'].errors && (formOuvidoria.controls['cep'].dirty || (formOuvidoria.controls['cep'].touched)|| submitted)" />
              <span class="text-danger"
                *ngIf="formOuvidoria.controls['cep'].errors?.['required'] && (formOuvidoria.controls['cep'].dirty || (formOuvidoria.controls['cep'].touched)|| submitted)">
                CEP é necessário.
              </span>
              <span class="text-danger"
                *ngIf="!formOuvidoria.controls['cep'].errors?.['required'] && (formOuvidoria.controls['cep'].dirty || (formOuvidoria.controls['cep'].touched)|| submitted) && formOuvidoria.controls['cep'].errors">
                CEP inválido.
              </span>

            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <input class="form-control global-input-style" formControlName="bairro" type="text" placeholder="Bairro"
                (change)="saverange($event, 'bairro')"
                [class.error]="formOuvidoria.controls['bairro'].errors && (formOuvidoria.controls['bairro'].dirty || (formOuvidoria.controls['bairro'].touched)|| submitted)" />

              <span class="text-danger"
                *ngIf="formOuvidoria.controls['bairro'].errors?.['required'] && (formOuvidoria.controls['bairro'].dirty || (formOuvidoria.controls['bairro'].touched)|| submitted)">
                Bairro é necessário.
              </span>
              <span class="text-danger"
                *ngIf="!formOuvidoria.controls['bairro'].errors?.['required'] && (formOuvidoria.controls['bairro'].dirty || (formOuvidoria.controls['bairro'].touched)|| submitted) && formOuvidoria.controls['bairro'].errors">
                Bairro inválido.
              </span>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <select class="form-select" formControlName="estado"
                [class.error]="formOuvidoria.controls['estado'].errors?.['required'] && (formOuvidoria.controls['estado'].dirty || (formOuvidoria.controls['estado'].touched)|| submitted)">
                <option value="" disabled [selected]="!formOuvidoria.controls['estado'].value">Selecione um estado
                </option>
                <option *ngFor="let estado of listaEstados" [value]="estado.nome">{{estado.nome}}</option>
              </select>
              <span class="text-danger"
                *ngIf="formOuvidoria.controls['estado'].errors?.['required'] && (formOuvidoria.controls['estado'].dirty || (formOuvidoria.controls['estado'].touched)|| submitted)">
                Selecione um estado.
              </span>

            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <select class="form-select " formControlName="cidade"
                [class.error]="formOuvidoria.controls['cidade'].errors?.['required'] && (formOuvidoria.controls['cidade'].dirty || (formOuvidoria.controls['cidade'].touched)|| submitted)">
                <option value="" *ngIf="formOuvidoria.controls['estado'].errors">Selecione um estado primeiro </option>
                <option value="" [selected]="!formOuvidoria.controls['cidade'].value"
                  *ngIf="!formOuvidoria.controls['estado'].errors">Selecione uma cidade</option>
                <option *ngFor="let cidade of listaCidades[0]" [value]="cidade">{{cidade}} </option>
              </select>
              <span class="text-danger"
                *ngIf="formOuvidoria.controls['cidade'].errors?.['required'] && (formOuvidoria.controls['cidade'].dirty || (formOuvidoria.controls['cidade'].touched)|| submitted)">
                Selecione a cidade.
              </span>
            </div>
          </div>
        </div>

        <div class="row ">
          <div class="col-md-12">

            <textarea class="form-control" id="mensagem" formControlName="mensagem" style="height:auto!important; resize: none "
              rows="6" placeholder="Qual seu problema?" (change)="saverange($event, 'mensagem')" (input)="contarCaracteres($event)"
              [class.error]="formOuvidoria.controls['mensagem'].errors && (formOuvidoria.controls['mensagem'].dirty || (formOuvidoria.controls['mensagem'].touched)|| submitted)"></textarea>

            <span class="text-danger"
              *ngIf="formOuvidoria.controls['mensagem'].errors?.['required'] && (formOuvidoria.controls['mensagem'].dirty || (formOuvidoria.controls['mensagem'].touched)|| submitted)">
              Mensagem é necessária.
            </span>
            <span class="text-danger"
              *ngIf="!formOuvidoria.controls['mensagem'].errors?.['required'] && (formOuvidoria.controls['mensagem'].dirty || (formOuvidoria.controls['mensagem'].touched)|| submitted) && formOuvidoria.controls['mensagem'].errors">
              Mensagem inválido. {{quantidadeCaracteres}} caractere(s) restante(s).
            </span>

          </div>

        </div>

        <div class="row mt-4">
          <div class="col-md-7">
            <div class="mb-3">
              <p class="font-gray-small min-area-form">
                Opção de envio de imagem ou arquivo <br />(JPG, PNG, PDF, DOC e DOCX)
              </p>
              <button
                type="button"
                (click)="anexarArquivo.click(); $event.preventDefault()"
                class="btn-ver-mais w-100 mb-2"
              >
                ANEXAR ARQUIVO
              </button>
              <input
                class="d-none"
                id="anexarArquivo"
                type="file"
                #anexarArquivo
                (change)="onFileSelect($event)"
                accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
              />
              <div *ngIf="fileTemp">
                Arquivo selecionado: {{ fileTemp.name }}
              </div>
            </div>

          </div>
          <div class="col-md-5">
            <div class="mb-2 mt-2 min-area-form">
              <div class="form-check form-check-inline mb-3">
                <input
                  (change)="aceitaReceberEmail($event)"
                  class="form-check-input"
                  type="checkbox"
                  id="check"
                />
                <label class="form-check-label font-gray-small" for="check"
                  >Desejo receber novidades e informações da Blukit em meu e-mail</label
                >
              </div>

            </div>

            <button [disabled]="submitted" class="btn-submit-form mb-2 mt-3">Enviar</button>
          </div>
        </div>



      </div>
    </form>
